import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import useAxios from "../../../../MainComponents/Hooks/useAxios";

export default function VideoTimedQuizModal({ open, question, onCorrect }) {
  const [selected, setSelected] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [submitState, setSubmitState] = useState({
    flag: "",
    dependency: false,
    data: {},
  });

  const [answerSuccess, answerErrors, answerLoading] = useAxios(
    process.env.REACT_APP_STUDENT_VIDEO_TIMED_ANSWER_API,
    "POST",
    submitState.flag,
    submitState.dependency,
    submitState.data,
    true
  );

  useEffect(() => {
    if (!answerSuccess || !submitState.flag) return;

    if (answerSuccess.is_correct === 1) {
      onCorrect?.(answerSuccess.unlocked_until_sec);
      setSelected("");
      setErrorMsg("");
    } else {
      setErrorMsg(answerSuccess.message || "إجابة خاطئة");
    }

    setSubmitState((prev) => ({ ...prev, flag: "" }));
  }, [answerSuccess]);

  useEffect(() => {
    if (!open) {
      setSelected("");
      setErrorMsg("");
    }
  }, [open, question?.id]);

  if (!open || !question) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selected) {
      setErrorMsg("اختر إجابة");
      return;
    }
    setErrorMsg("");
    setSubmitState({
      flag: "answer",
      dependency: !submitState.dependency,
      data: {
        timed_question_id: question.id,
        student_answer: selected,
      },
    });
  };

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 p-4">
      <div className="w-full max-w-xl rounded-2xl bg-white p-6 shadow-2xl dark:bg-[#121a35] dark:text-slate-100">
        <h3 className="mb-4 text-lg font-bold text-secondary">
          لازم تحل السؤال عشان تكمل الفيديو
        </h3>
        <div
          className="mb-5 text-base font-semibold"
          dangerouslySetInnerHTML={{
            __html: question.question?.question || "",
          }}
        />
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          {question.question?.answers?.map((ans) => (
            <label
              key={ans.order}
              className={`flex cursor-pointer items-start gap-3 rounded-xl border p-3 transition ${
                selected === ans.order
                  ? "border-secondary bg-secondary/10"
                  : "border-slate-200 dark:border-[#2a3a66]"
              }`}
            >
              <input
                type="radio"
                name="timed_answer"
                value={ans.order}
                checked={selected === ans.order}
                onChange={() => setSelected(ans.order)}
              />
              <span className="font-bold text-secondary">{ans.order}.</span>
              <span dangerouslySetInnerHTML={{ __html: ans.answer || "" }} />
            </label>
          ))}

          {(errorMsg || answerErrors?.response?.data?.message) && (
            <p className="text-sm text-red-500">
              {errorMsg || answerErrors?.response?.data?.message}
            </p>
          )}

          <button
            type="submit"
            disabled={answerLoading && submitState.flag}
            className="mt-2 rounded-xl bg-secondary px-4 py-2 font-bold text-white"
          >
            {answerLoading && submitState.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              "تأكيد الإجابة"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
